import React from 'react';
import { useTranslation } from 'react-i18next';
import { NullableLink } from '../../layout/NoServices';
import { configuration } from 'config/constants';
import { useAppSelector } from 'store/store';

export const FormLink = () => {
    const { t: translate } = useTranslation('service-list');
    const { nonSgmLinkReferentialUrl } = configuration;
    const formUrl = nonSgmLinkReferentialUrl || null;
    const isSgGroup = useAppSelector(state => state.applicationContext.context?.isSgGroupCurrentUser);

    if (!isSgGroup) {
        return null;
    }

    return <div className="d-flex align-items-center mt-3 text-secondary"        >
        <span>
            <i className="icon icon-sm">info_outlined</i>
        </span>
        <span>
            {translate('service-list:formLinkBefore')}
            <NullableLink href={formUrl}                >
                {translate('service-list:formLinkInner')}
            </NullableLink>
            {translate('service-list:formLinkAfter')}
        </span>
    </div>;
};
